import React from "react";
import style from "./index.module.scss";
import { ExperiState, ExperiStateMap } from "service/experiment";
import classNames from "classnames";

interface StatusProps {
    status: ExperiState;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {ExperiStateMap[status]}
        </span>
    );
}
